import { isSafeRedirectUrl, generateRedirectUrl } from './redirectUtils';

export const goToAuth = (isEnter: boolean = false) => {
  const redirectUrl = generateRedirectUrl('');

  if (isSafeRedirectUrl(redirectUrl)) {
    if (isEnter) {
      window.location.href = redirectUrl;
      return;
    }
    document.dispatchEvent(new CustomEvent('openNotification'));
    setTimeout(() => {
      window.location.href = redirectUrl;
    }, 4000);
  } else {
    console.warn("Попытка небезопасного редиректа была предотвращена.");
  }
};
